/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ThemeSettingsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const themeSettingsEntryPoint: EntryPoint<ThemeSettingsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<ThemeSettingsEntryPointComponent>(
			/* webpackChunkName: "async-insight-global-configuration-theme-settings" */ './ThemeSettingsMain.tsx',
		),
		getPreloadProps: () => ({}),
	});
